export default __webpack_public_path__ + "static/media/step_3.4bbcf358.png";